import { type Enum } from '@webapp/utils'

export const SpendingCardFundListTabs = {
  OPEN: 'open',
  CLOSED: 'closed',
} as const
export type SpendingCardFundListTab = Enum<typeof SpendingCardFundListTabs>
